
"use client";

import { identifyVisitor } from './visitor-identification';

export interface UserInfo {
    fullName: string;
    phone: string;
    email?: string;
}

/**
 * Gets or creates visitor and user information
 */
export function getContactInfo(organizationId: string) {
    // Get visitor info
    const visitorInfo = identifyVisitor(organizationId);

    // Check if we have user info stored
    const userStorageKey = `flowapt_user_${organizationId}`;
    const savedUserInfo = localStorage.getItem(userStorageKey);

    let userInfo: UserInfo | null = null;
    if (savedUserInfo) {
        userInfo = JSON.parse(savedUserInfo);
    }

    return {
        visitorInfo,
        userInfo,
        saveUserInfo: (data: UserInfo) => {
            localStorage.setItem(userStorageKey, JSON.stringify(data));
            return data;
        }
    };
}
